import validate from "validate.js";

const formPresenceMessage = (attribute) => `^${attribute} can't be empty.`;
const constraints = {
  displayName: {
    presence: {
      message: formPresenceMessage("Display name"),
      allowEmpty: false,
    },
  },
  vectorType: {
    presence: {
      message: formPresenceMessage("Vector Type"),
      allowEmpty: false,
    },
  },
  trapType: {
    presence: {
      message: formPresenceMessage("Trap Type"),
      allowEmpty: false,
    },
  },

};

const validateForm = ({ displayName, vectorType, trapType }) => {
  const errors = validate(
    {
      displayName,
      vectorType,
      trapType,
    },
    constraints
  );
  return errors;
};

export default validateForm;
